import { default as Channels } from './Channels';

export default Channels;
